import { isMatch } from 'date-fns'
import { zonedTimeToUtc } from 'date-fns-tz'

import { getCurrentJstDate } from './datetimes'

import { TIMEZONE } from '../constants'

export const isReceiptAvailableJst = (checkOutDate?: string) => {
  // Missing or malformed checkout dates must not unlock a receipt.
  if (!checkOutDate || !isMatch(checkOutDate, 'yyyy-MM-dd')) return false
  return getCurrentJstDate() >= checkOutDate
}

export const getReceiptAvailabilityDelayJst = (checkOutDate?: string) => {
  if (!checkOutDate || !isMatch(checkOutDate, 'yyyy-MM-dd')) return 0
  return Math.max(
    0,
    zonedTimeToUtc(checkOutDate, TIMEZONE).getTime() - Date.now()
  )
}
